<template>
  <div v-bind="attrs" v-if="$attrs.isLoading">
    <v-skeleton-loader type="button,text,button"> </v-skeleton-loader>
    <v-skeleton-loader type="button@6"> </v-skeleton-loader>
    <v-skeleton-loader type="button@6"> </v-skeleton-loader>
    <v-skeleton-loader type="button@6"> </v-skeleton-loader>
  </div>
  <div v-else>
    <v-card v-if="$attrs.slots" :class="['timeSlots', $attrs.tripStyle == '' ? 'tripStyle' : '']">
      <v-card-title class="py-1" v-if="$attrs.label">{{ $attrs.label }}</v-card-title>
      <v-card-text>
        <v-btn
          :class="[Value.includes(n) ? 'active' : '']"
          v-ripple="false"
          v-for="n in $attrs.slots"
          :key="n.id"
          @click.native="selectTime(n)"
          >{{ n }}</v-btn
        >
      </v-card-text>
    </v-card>
    <v-menu
      v-else-if="$attrs.popup === '' || $attrs.popup == true"
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="fade-transition"
      offset-y
      min-width="290px"
      v-bind="$attrs"
    >
      <template v-slot:activator="{ on }">
        <edn-field
          :required="$attrs.required"
          :ename="$attrs.ename"
          :id="$attrs.id"
          v-model="Value"
          :disabled="$attrs.disabled"
          :label="$attrs.label"
          v-on="on"
          v-on:click:append="menu = true"
          :rules="rules"
          append-icon="mdi-clock-time-four"
        ></edn-field>
      </template>

      <v-time-picker
        ref="timePicker"
        :color="colors.primary"
        :format="'24hr'"
        v-bind="$attrs"
        @click:minute="$refs.menu.save(Value)"
        close-on-content-click="false"
        v-model="Value"
        :min="min"
      >
      </v-time-picker>
    </v-menu>
    <v-time-picker
      ref="timePicker"
      v-else
      :color="colors.primary"
      format="24hr"
      v-bind="$attrs"
      close-on-content-click="false"
      v-model="Value"
      :min="min"
      v-on="$listeners"
    >
    
    </v-time-picker>
  </div>
</template>


<script>
import { ednRequired } from './mixins/ednRequired'
import { ednValue } from './mixins/ednValue'

export default {
  inheritAttrs: false,
  mixins: [ednRequired, ednValue],
  data() {
    return {
      menu: null,
      colors: {
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary,
      },
      timeValue:null
    }
  },
  computed: {
      Value: {
          get() {
              return this.timeValue || this.value;
          },
          set(newVal) {
            this.timeValue = newVal;
            this.$emit('input', newVal);
          }
      }
  },
  props: {
    value: {
      type: String,
      default: () => null,
    },
    min: {
      type: String,
      default: () => null,
    },
  },
  methods: {
    selectTime(time) {
      if (typeof this.Value !== 'object') {
        this.Value = []
      }
      if (this.Value == [] || (this.Value != time && this.Value != [] && !this.Value.includes(time))) {
        this.Value.push(time)
      } else if (this.Value.includes(time)) {
        let pos = this.Value.indexOf(time)
        this.Value.splice(pos, 1)
      }
    },
    resetSelect(param) {
      if (param === 'clear') this.Value = ''
      this.$refs.timePicker.selecting = 1
    },
    selectMin() {
      this.$refs.timePicker.selecting = 2
    },
  },
}
</script>
<style lang="scss">
.timeSlots {
	&.tripStyle {
		&.v-card {
			&.v-sheet {
				background-color: #fafafa;
				background-color: #fff;
				transition: all 0.3s;
				box-shadow: 0 1px 0 0 #c5c5ca;
				margin: 2px;
				border-radius: 0.4em;
				&.v-date-picker-table__current {
					border: none;
					box-shadow: 0 1px 0 0 var(--v-primary-lighten1), inset 0 -1px 0 0 var(--v-primary-base);
				}
				&:hover {
					margin-top: -1px;
					box-shadow: 0 1px 0 0 #c5c5ca, inset 0 -1px 0 0 #4e4e56;
					&::before {
						opacity: 0;
					}
				}
			}
		}
	}
	button {
		&.v-btn {
			&.active {
				&.v-btn--contained {
					&.theme--light {
						background-color: var(--v-primary-base);
						color: #fff;
					}
				}
			}
		}
	}
	div {
		&.v-card__text {
			display: grid;
			grid-template-columns: auto auto auto;
		}
	}
}
.timeSlots.tripStyle.v-card.v-sheet button.v-btn,
.timeSlots.tripStyle.v-card.v-sheet.v-btn--disabled {
	background-color: transparent;
	box-shadow: none;
}

</style>
